export default {
    methods: {
        isEventTargetWithinElement: function (event, desiredElement) {
            var currentElement = event.target;
            if (currentElement == null) {
                return false;
            }
            while ((currentElement != desiredElement) && currentElement.parentNode) {
                currentElement = currentElement.parentNode;
            }
            return (currentElement == desiredElement);
        }
    }
}